import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {
  faArrowDown,
  faCalendarCheck,
  faEye,
} from '@fortawesome/free-solid-svg-icons'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  DcBreadcrumbs,
  DcButton,
  DcFlexBox,
  PixelCurrency,
  PixelIcon,
  PixelModal,
  PixelPageContainer,
  PixelTable,
  PixelTableAction,
  PixelTag,
  Section,
  SectionContent,
} from 'pixel-base'

import { getVendorsCalculatedPayment } from 'utils/api-routes.util'

import MarkAsPaid from './MarkAsPaid'

const breadcrumbs = [
  {
    name: 'Vendors',
    active: false,
    link: '/vendors/',
  },
  {
    name: 'Payments',
    active: true,
  },
]

const Payments = () => {
  const navigate = useNavigate()
  const params = useParams()

  const [paidpopup, setPaidPopup] = React.useState(false)
  const [tableLoading, setTableLoading] = React.useState(true)
  const [payment, setPayment] = React.useState([])
  const [markAsPaid, setMarkAsPaid] = React.useState()
  const id = params.id
  const getVendorPayments = () => {
    setTableLoading(true)
    getVendorsCalculatedPayment(id).subscribe((res: any) => {
      setPayment(res.response.data)
      setTableLoading(false)
    })
  }

  React.useEffect(() => {
    getVendorPayments()
  }, [])
  const columns = [
    {
      dataKey: 'billing_month',
      name: 'Billing Month',
      sortable: true,
      selector: (row) => row.billing_month || '--',
    },
    {
      dataKey: 'contract_name',
      name: 'Contract Name',
      sortable: true,
      selector: (row) =>
        (row.contract_name && (
          <PixelTag className="primary">{row.contract_name}</PixelTag>
        )) || <PixelTag className="primary">No Contract</PixelTag>,
    },
    {
      dataKey: 'order_count',
      name: 'Total Orders',
      sortable: true,
      selector: (row) => row.order_count || '--',
    },
    {
      dataKey: 'order_total_amount',
      name: 'Total Amount',
      sortable: true,
      selector: (row) => (
        <PixelCurrency value={row.order_total_amount} currency={'USD'} />
      ),
    },
    {
      dataKey: 'order_commission_amount',
      name: 'Commission',
      sortable: true,
      selector: (row) => (
        <PixelCurrency value={row.order_commission_amount} currency={'USD'} />
      ),
    },
    {
      dataKey: 'pay_date',
      name: 'Payment Date',
      sortable: true,
      selector: (row) => row.pay_date || '--',
    },
    {
      dataKey: 'is_paid',
      name: 'Payment Status',
      sortable: true,
      selector: (row) =>
        row.is_paid === true ? (
          <PixelTag className="success">paid</PixelTag>
        ) : (
          <PixelTag className="danger">Unpaid</PixelTag>
        ),
    },
    {
      dataKey: 'actions',
      name: 'Actions',
      selector: (row) => <PixelTableAction row={row} action={actions} />,
    },
  ]
  const actions = [
    {
      title: 'View Orders',
      icon: (
        <>
          <Section>
            <PixelIcon icon={faEye} />
          </Section>
        </>
      ),
      clickHandler: (row) => {
        navigate(`/orders?vendor_id=${row.vendor_id}&status=all`)
      },
    },
    {
      title: 'Mark as Paid',
      icon: (
        <>
          <Section>
            <PixelIcon icon={faCalendarCheck} />
          </Section>
        </>
      ),
      clickHandler: (row) => {
        setPaidPopup(true)
        setMarkAsPaid(row)
        // navigate(`/vendors/payments/${row.vendor_id}`);
      },
    },
  ]
  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{ fontSize: '16px', padding: '8px 0px' }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>
      <DcFlexBox
        justifyContent="flex-end"
        height="auto"
        padding="0px 20px 5px 20px"
      >
        <DcButton
          // onClick={() => {
          //   setShowNewModal(true);
          // }}
          size="sm"
        >
          <PixelIcon icon={faArrowDown} /> Export
        </DcButton>
      </DcFlexBox>
      <PixelPageContainer>
        <Section>
          <SectionContent>
            <PixelTable
              columns={columns}
              highlightOnHover={true}
              data={payment}
              progressPending={tableLoading}
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
      <PixelModal
        // size={"sm"}
        title={'Process Settled Payment'}
        handleClose={() => setPaidPopup(false)}
        show={paidpopup}
      >
        {paidpopup && (
          <MarkAsPaid
            markAsPaid={markAsPaid}
            handleClose={(data) => {
              setPaidPopup(false)
              setPayment(data)
            }}
          />
        )}
      </PixelModal>
    </>
  )
}

export default Payments
